<template>
  <div>
    <div class="usrBox">
      <van-divider content-position="left">预警</van-divider>
      <van-grid class="shebei" :border="false" :column-num="2">
        <van-grid-item to="SimList/1">
          <div class="header1 leftBtn">
            <div class="sbDiv">
              <p>套餐临期(7天)</p>
              <span>{{this.adventEqp}}</span>
            </div>
          </div>
        </van-grid-item>
        <van-grid-item to="SimList/2">
          <div class="header1 rightBtn">
            <div class="sbDiv ssd">
              <p>流量不足(5M)</p>
              <span>{{this.lackEqp}}</span>
            </div>
          </div>
        </van-grid-item>
      </van-grid>
      <van-divider content-position="left">已停机</van-divider>
      <van-grid class="shebei" :border="false" :column-num="3">
        <van-grid-item to="SimList/3">
          <div class="header1 leftBtn2">
            <div class="sbDiv">
              <p>流量超额</p>
              <span>{{this.overFlowEqp}}</span>
            </div>
          </div>
        </van-grid-item>
        <van-grid-item to="SimList/4">
          <div class="header1 rightBtn2">
            <div class="sbDiv ssd">
              <p>机卡分离</p>
              <span>{{this.offEqp}}</span>
            </div>
          </div>
        </van-grid-item>
        <van-grid-item to="SimList/5">
          <div class="header1 rightBtn2">
            <div class="sbDiv ssd">
              <p>静默停机</p>
              <span>{{this.silenceEqp}}</span>
            </div>
          </div>
        </van-grid-item>
      </van-grid>
      <van-divider content-position="left">快捷功能</van-divider>
      <van-grid :border="false" :column-num="3">
        <div class="box" v-for="(item, index) in list" :key="index">
          <van-grid-item :to="item.push" :text="item.text">
            <template slot="icon">
              <span :class="item.icon"></span>
            </template>
          </van-grid-item>
        </div>
      </van-grid>
      <div class="footer">
        <!-- <p>侵权必究 2021</p> -->
      </div>
    </div>
  </div>
</template>

<script>
import {
  SimStat
} from '@/api/Equipment.js'
export default {
  components: {},
  props: {},
  data () {
    // van-icon van-icon-vip-card-o
    return {
      list: [{
        text: '我的分润',
        icon: 'iconfont icon-jiagebiao- yellow',
        push: 'Balance'
      },
      {
        text: '流量订单',
        icon: 'iconfont icon-chaxun greend',
        push: 'Order'
      },
      {
        text: '预存账户',
        icon: 'iconfont icon-yue deepBlue',
        push: 'BalancePre'
      },
      {
        text: '分享',
        icon: 'iconfont icon-lianjie greend',
        push: 'QRcode'
      },
      {
        text: '拓展代理',
        icon: 'iconfont icon-dailishang greend',
        push: 'AgentManagement'
      },
      {
        text: '账户设置',
        icon: 'iconfont icon-xiugai greend',
        push: 'AccountSetup'
      }
      // {
      //   text: '销售定价',// todo
      //   icon: 'iconfont icon-xiugai greend',
      //   push: 'PackageConfig'
      // }
      ],
      adventEqp: '',
      lackEqp: '',
      offEqp: '',
      silenceEqp: '',
      overFlowEqp: '',
      topUsername: '',
      rank: '',
      ranks: '',
      // 等级进度
      percentageNum: 70
    }
  },
  watch: {},
  computed: {},
  methods: {
    // 超流量数量,已停机数量
    async mobileIndex () {
      const {
        data: res
      } = await SimStat({
        token: this.$store.state.token,
        userId: this.$store.state.userID.split('a')[0]
      })
      this.adventEqp = res.adventEqp ? res.adventEqp : 0
      this.lackEqp = res.lackEqp ? res.lackEqp : 0
      this.offEqp = res.offEqp ? res.offEqp : 0
      this.overFlowEqp = res.overFlowEqp ? res.overFlowEqp : 0
      this.silenceEqp = res.silenceEqp ? res.silenceEqp : 0

      this.$store.commit('setAdventEqp', res.adventEqp)
      this.$store.commit('setLackEqp', res.lackEqp)
      this.$store.commit('setOffEqp', res.offEqp)
      this.$store.commit('setOverFlowEqp', res.overFlowEqp)
      this.$store.commit('setSilenceEqp', res.silenceEqp)
    }
  },
  beforeCreate () {
    if (!this.$store.state.token) {
      this.$router.push('/login/no')
      this.$toast.fail('请重新登录')
    }
  },
  created () {
    this.lackEqp = this.$store.state.lackEqp
    this.adventEqp = this.$store.state.adventEqp
    this.offEqp = this.$store.state.offEqp
    this.overFlowEqp = this.$store.state.overFlowEqp
    this.silenceEqp = this.$store.state.silenceEqp
    const agentName = this.$store.state.agentName
    this.topUsername = (agentName && agentName !== 'undefined') ? this.$store.state.agentName : this.$store.state
      .userName
    this.mobileIndex()
  },
  mounted () {}
}
</script>

<style scoped lang='less'>
  .usrBox {
    padding: 5px 25px 0;
    height: 100%;
    padding-bottom: 100px;
    box-sizing: border-box;

    .header {
      height: 326px;
      width: 100%;
      border-radius: 15px;
      background-color: red;
      background: url(../../../assets/home-banner.png) no-repeat center;
      background-size: 100% 385px;
      overflow: hidden;
      padding-top: 30px;
      color: #fff;

      .info {
        font-size: 36px;
      }

      .degree {
        padding-top: 25px;
        font-size: 30px;

        /deep/.van-progress__pivot {
          display: none;
        }
      }

      .item {
        padding-top: 40px;
        text-align: center;
        font-size: 26px;
      }
    }

    .box {
      width: 29%;
      height: 185px;
      background-color: #fff;
      margin: 12px 2%;
      box-shadow: 0 4px 10px 5px rgba(15, 27, 115, 8%);
      border-radius: 15px;
      position: relative;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 8px;
      font-weight: 400;

      .van-grid-item {
        flex: 1;
        padding-right: 0 !important;
        height: 80%;
      }

      /deep/.van-grid-item__content {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        padding: 15px;
      }
    }

    .shebei {
      /deep/.van-grid-item__content {
        padding: 3px 8px;

        .header1 {
          height: 142px;
          width: 100%;
          border-radius: 15px;
          color: #fff;

          .sbDiv {
            display: flex;
            height: 100%;
            flex-direction: column;
            justify-content: space-around;
            align-items: center;
            padding: 24px 0 0;

            p {
              font-size: 32px;
            }

            span {
              font-size: 36px;
            }
          }
        }

        .leftBtn {
          background: url(../../../assets/Stream-2.png) no-repeat center;
          background-size: cover;
        }

        .rightBtn {
          background: url(../../../assets/Stream-1.png) no-repeat center;
          background-size: cover;
        }

        .leftBtn2 {
          background: url(../../../assets/Stream-4.png) no-repeat center;
          background-size: cover;
        }

        .rightBtn2 {
          background: url(../../../assets/Stream-3.png) no-repeat center;
          background-size: cover;
        }
      }
    }

    .van-cell-group {
      margin-top: 15px;
      overflow-y: scroll;
      height: 1100px;

      .van-cell:last-child {
        color: #AFAFB8;
        text-align: center;
      }
    }

    /deep/.van-divider {
      margin: 18px 0;
      font-size: 24px !important;
      color: rgba(51, 51, 51, 0.6);
    }

    .van-divider--content-left::before {
      max-width: 0%;
      margin: 0;
    }
  }

  [class*=van-hairline]::after {
    border: none;
  }

  .greend {
    color: #5dcd96;
  }

  .blue {
    color: #1296db;
  }

  .deepBlue {
    color: #13227a;
  }

  .pinkRed {
    color: #ff9383;
  }

  .yellow {
    color: #ffa347;
  }

  .box span {
    font-size: 68px;
    margin-bottom: 10px;
  }

  .samles {
    font-size: 50px !important;
  }

  .footer {
    width: 100%;
    text-align: center;

    p {
      font-size: 25px;
      color: #bbbbbb;
    }

    margin: 5px 0 15px;
  }
</style>
